import {Tag, TagCloseButton, TagLabel} from '@chakra-ui/react';
import React from 'react';

// Tag affiché sous la FilterBar desktop pour chaque filtre actif (label, fromage, température...).
// Clic sur la croix → retire le filtre via `onRemove`.

interface FilterBarTagProps {
  label: string;
  onRemove: () => void;
}

export const FilterBarTag: React.FC<FilterBarTagProps> = ({
  label,
  onRemove,
}) => (
  <Tag
    size='md'
    bg='gray.100'
    borderRadius='8px'
  >
    <TagLabel>{label}</TagLabel>
    <TagCloseButton onClick={onRemove} />
  </Tag>
);
